import styled, { css } from "styled-components";
import {
  Container,
  Grid,
  Select,
  Icon,
  Checkbox,
  Table,
  Modal,
} from "semantic-ui-react";
// import Modal from "react-modal";

const SyledContainer = styled(Container)`
  margin: 1em;
`;

const StyledGridRow = styled(Grid)`
  border: 1px solid #E3E6EA;
  box-shadow: 1px 2px 3px -1px #E3E6EA;
  margin-top: 6px !important;
  margin-bottom: -20px !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  border-radius: 10px;
  overflow: hidden;
  &.no-shadow{
    box-shadow: none;
    margin-bottom: 0 !important;
    margin-top: 0 !important;
    border-top: none;
    border-top-radius: none;
    .fields{
      .disabled.field{
        opacity: 1;
        label{
          color: #5E6773 !important;
          opacity: .8;
        }
        .ui.input input{
          color: #5E6773 !important;
          border-color: #5E6773 !important;
          opacity: .8;
          &::-webkit-input-placeholder { /* Edge */
            color: #5E6773 !important;
            opacity: .8;
          }
          
          &:-ms-input-placeholder { /* Internet Explorer 10-11 */
            color: #5E6773 !important;
            opacity: .8;
          }
          
          &::placeholder {
            color: #5E6773 !important;
            opacity:0.8;
          }
        }
      }
      &.headerInline{
       
        .field{
          label{
            min-width: 45px;
          }
        }
      }
      .field{
        display:flex;
        flex-direction: row;
        align-items:center;
        &.addl_info_datepicker{
          width: 100% !important;
          label{
            display: inline-block;
            width: 100px;
          }
          .ui.input{
            &.rdtOpen{
              .rdtPicker{
                margin-top: 40px;
              }
            }
          }
        }
        &.addl_info_field{
          .ui.input{
            
            margin-left: 5px;
            input::-webkit-input-placeholder { /* Edge */
              color: #5E6773 !important;
            }
            
            input:-ms-input-placeholder { /* Internet Explorer 10-11 */
              color: #5E6773 !important;
            }
            
            input::placeholder {
              color: #5E6773 !important;
            }
          }
        }
      }
    }
  }
  &.noMargin{
    margin: 0 !important;
  }
  .row {
    margin: 0;
    border-radius: inherit;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    &.padd {
      padding: 20px 6px !important;
    }
  }
  .bg-lightGrey {
    background: #eef1f2;
  }
  &.noborder {
    .row {
      padding-top: 0 !important;
    }
    &.top4Em {
      margin-top: 5em !important;
    }
  }

  .dropdown .text {
    @media screen and (max-width: 1023px) {
      font-size: 12px;
    }
  }
  &.nooverflow{
    overflow: unset;
  }
  .searchControls {
    .column {
      label {
        color: #5e6773 !important;
        margin-bottom: 10px !important;
        font-weight: 400 !important;
        display: block;
      }
    }
  }
`;

const StyledTable = styled(Table)`
  &.basic.table {
    border: 0px !important;
    border-collapse: collapse;
    tr {
      border: 0px !important;
    }
    tr td,
    tr th {
      border: 0px !important;
      cursor: pointer;
      color: #5e6773 !important;
    }
    tr th:last-child,
    tr td:last-child {
      padding: 0 60px 0 0;
      width: 40px;
      text-align: center;
      vertical-align: middle;
      .trash {
        color: #212529;
      }
    }
    tr th:first-child,
    tr td:first-child {
      padding-left: 60px;
      padding-right: 60px;
      width: 30%;
    }
    tr td.type {
      width: 18%;
    }
    tfoot {
      th {
        border: 0px !important;
        padding-top: 20px !important;
        padding-bottom: 20px !important;
        padding-left: 20px !important;
        padding-right: 20px !important;
      }
    }
  }
  .row {
    cursor: pointer;
  }
  &.audit-logs{
    td, th {
      text-align: left !important;
      width: 100% !important;
    }
  }
`;

const StyledSelect = styled(Select)`
  display: block;
  .divider {
    height: auto;
    float: left;
    margin: 0px;
    border-left: none;
}
  .icon {
    cursor: pointer;
    position: absolute;
    width: auto;
    height: auto;
    line-height: 1em;
    top: 0.7em;
    right: 1em;
    z-index: 3;
    margin: -0.78571429em;
    padding: 0.91666667em;
    opacity: 0.8;
    transition: opacity 0.1s ease;
  }
`;

const ActiveInd = styled.span`
  color: ${(props) => (props.active ? "#00BC6E" : "#F65200")};
  font-weight: bold;
`;

const ToolTip = styled.div`
  span {
    i {
      font-style: normal;

      &::after {
        content: ",";
        margin-right: 3px;
      }
      &:last-child::after {
        content: "";
      }
    }
  }
`;

const SuperScript = styled.sup`
  display: inline-block;
  background: #f9bd0a;
  margin: 5px;
  padding: 6px 6px;
  border-radius: 50px;
  font-size: 8px;
  font-weight: 700;
  height: 13px;
  position: relative;
  top: -5px;
`;
const Counter = styled(Icon)`
  &:before {
    contetnt: "1" !important;
  }
`;

const StyledModal = styled(Modal)`
  z-index: 1200;
  &.ui.modal {
    position: relative;
  }
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  overflow:hidden;
`;

const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  background: #0190d0;
  padding: 10px;
  align-items: center;
  justify-content: space-between;
  ${(props) =>
    props.regular &&
    css`
      font-size: 18px;
      background: #eef1f2;
      padding: 20px;
    `}
  span {
    width: 5%;
    display: inline-flex;
    background: red;
    height: 100%;
  }
  h2 {
    font-size: 18px;
    font-weight: normal;
    color: #fff;
    width: 60%;
    height: 100%;
    margin: 0;
    text-align: center;
  }
  i {
    align-self: right;
    font-size: 20px;
    width: 5%;
    display: inline-flex;
    height: 100%;
    color: #fff;
    font-weight: normal;
    text-align: right;
    justify-content: flex-end;
    cusrsor: pointer;
    &:before {
      cursor: pointer;
    }
  }
`;
const ModalFooter = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0 50px 30px 50px;
  justify-content: flex-end;
  align-items: center;
  button {
    margin-left: 20px !important;
  }
`;
const ModalBody = styled.div`
  display: flex;
  flex-direction: row;
  padding: 30px 40px 0;
  .ui.grid {
    margin: 0px !important;
    width: 100%;
    border: 0 !important;
    box-shadow: none;
  }
  .field label {
    color: #5e6773 !important;
    margin-bottom: 10px !important;
    font-weight: 400 !important;
  }
  .field {
    padding-bottom: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    .ui.checkbox {
      align-self: flex-start;
      justify-content: flex-start;
      top: 15px;

      &.ui.checkbox input ~ .box:before,
      &.ui.checkbox input ~ label:before {
        border: 1px solid #eef1f2;
        box-shadow: 0px 1px 2px 1px #d8dada52;
        width: 20px;
        height: 20px;
        top: -2px;
        margin-right: -15px;
      }
      &.ui.checkbox input:checked ~ .box:after,
      &.ui.checkbox input:checked ~ label:after {
        content: "\f14a" !important;
        color: #0190d0;
        font-size: 22px;
        font-family: Icons;
      }
      label {
        color: #2d3b4e;
        font-size: 16px;
        &:first-letter {
          margin-left: 5px;
        }
      }
    }
  }
`;

const StyledCheckBox = styled(Checkbox)`
  top: 5px;
  &.ui.checkbox input ~ .box:before,
  &.ui.checkbox input ~ label:before {
    border: 1px solid #eef1f2;
    box-shadow: 0px 1px 2px 1px #d8dada52;
    width: 20px;
    height: 20px;
    top: -2px;
  }
  &.ui.checkbox input:checked ~ .box:after,
  &.ui.checkbox input:checked ~ label:after {
    content: "\f14a" !important;
    color: #0190d0;
    font-size: 22px;
    font-family: Icons;
  }
  label {
    color: #2d3b4e;
    font-size: 16px;
    &:first-letter {
      margin-left: 5px;
    }
  }
  margin-bottom: 10px;
`;

const ZebraList = styled.ul`
  border: 1px solid #eef1f2;
  box-shadow: 0px 1px 2px 1px #d8dada52;
  margin-left: 0 !important;
  margin-right: 0 !important;
  border-radius: 10px;
  padding: 0;
  li {
    display: flex;
    flex-direction: row;
    align-items: center;
    list-style: none;
    &:nth-child(2n) {
      background: #eef1f2;
    }
    padding: 8px 20px 0px;
  }
`;

const Textlink = styled.a`
  font-size: 14px;
  color: #162c4a;
  line-height: 16px;
  font-weight: 600;
`;

const FormErrorLabel = styled.label`
  font-size: 12px;
  color: #ff0000;
  position: absolute;
  bottom: 20px;
`;

export {
  SyledContainer,
  StyledGridRow,
  StyledTable,
  StyledSelect,
  ActiveInd,
  ToolTip,
  SuperScript,
  Counter,
  ModalContent,
  ModalHeader,
  StyledModal,
  ModalFooter,
  ModalBody,
  StyledCheckBox,
  ZebraList,
  Textlink,
  FormErrorLabel,
};
